import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {withStyles} from '@material-ui/core/styles';

import {helper} from '../common/common';
import LoadRegion from '../controls/LoadRegion';
import Sidebar from './tasking/Sidebar';
import Map from './tasking/Map';
import Selection from './tasking/Selection';
import SelectionConfirm from './tasking/SelectionConfirm';
import SelectionDone from './tasking/SelectionDone';

const styles = (theme) => {
    return {
    };
}

const Stage = Object.freeze({
    initial: 0,
    selection: 1,
    confirm: 2,
    done: 3,
});

class Tasking extends Component {
    constructor(props) {
        super(props);

        document.title = 'Tasking \u00b7 Alpha2';

        this.state = {
            regionListTimestamp: 0,
            regionList: [],
            regionIndex: 0,
            overlayInfo: {},
            stage: Stage.initial,
        }

        this._regionInfo = {};
        this._selectedAnalysis = [];

        this._loadRegion = new LoadRegion(
            this._handleLoadMapping, this._processError, this.props.getAccessCode, false);
    }

    componentDidMount = () => {
        this._queryMapping(this.props.sharedProps.region);
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        return (this.state.regionListTimestamp !== nextState.regionListTimestamp ||
            this.state.regionIndex !== nextState.regionIndex ||
            this.state.overlayInfo.uid !== nextState.overlayInfo.uid ||
            this.state.stage !== nextState.stage);
    }

    componentWillUnmount = () => {
        this._loadRegion.unmount();
    }

    render = () => {
        return (
            <div>
                <Sidebar
                    regionListTimestamp={this.state.regionListTimestamp}
                    regionList={this.state.regionList}
                    regionDefaultIndex={this.state.regionIndex}
                    getAccessCode={this.props.getAccessCode}
                    onChangeRegion={this._handleChangeRegion}
                    onSelectCard={this._handleSelectCard}
                    onError={this.props.onError}
                    overlayInfo={this.state.overlayInfo}
                />
                <Map
                    regionListTimestamp={this.state.regionListTimestamp}
                    regionList={this.state.regionList}
                    regionIndex={this.state.regionIndex}
                    overlayInfo={this.state.overlayInfo}
                    getAccessCode={this.props.getAccessCode}
                    onDone={this._handleDone}
                    onCancel={this._handleCancelCard}
                    onError={this.props.onError}
                />
                <Selection
                    open={this.state.stage === Stage.selection}
                    regionInfo={this._regionInfo}
                    overlayInfo={this.state.overlayInfo}
                    getAccessCode={this.props.getAccessCode}
                    onNext={this._handleSelectionNext}
                    onCancel={this._handleSelectionCancel}
                    onError={this.props.onError}
                />
                <SelectionConfirm
                    open={this.state.stage === Stage.confirm}
                    regionInfo={this._regionInfo}
                    overlayInfo={this.state.overlayInfo}
                    selectedAnalysis={this._selectedAnalysis}
                    getAccessCode={this.props.getAccessCode}
                    onNext={this._handleConfirmNext}
                    onCancel={this._handleConfirmCancel}
                    onError={this.props.onError}
                />
                <SelectionDone
                    open={this.state.stage === Stage.done}
                    onOk={this._handleDoneOk}
                />
            </div>
        );
    }

    _queryMapping = (hint) => {
        this._loadRegion.query(hint);
    }

    _handleLoadMapping = (timeStamp, list, defaultIndex) => {
        this.setState({
            regionListTimestamp: timeStamp,
            regionList: list,
            regionIndex: defaultIndex,
        });
    }

    _handleChangeRegion = (index) => {
        this.setState({
            regionIndex: index,
            overlayInfo: {},
        });

        if (this.props.setSharedProps) {
            this.props.setSharedProps({
                region: this.state.regionList[index].properties.key,
            })
        }
    }

    _handleSelectCard = (info) => {
        this.setState({
            overlayInfo: info,
        });
    }

    _handleCancelCard = () => {
        this.setState({
            overlayInfo: {},
        });
    }

    _handleDone = () => {
        this._regionInfo = this.state.regionList[this.state.regionIndex].properties;

        if (!this._regionInfo.size) {
            this.setState({
                stage: Stage.initial,
                overlayInfo: {},
            });

            this._processError(helper.makeError('Missing Size',
                'No area information was found for this region', 'warn_only'));
        } else {
            this.setState({
                stage: Stage.selection,
            });
        }
    }

    _handleSelectionNext = (selectedAnalysis) => {
        this._selectedAnalysis = [];

        Object.entries(selectedAnalysis).forEach(([index, value]) => {
            this._selectedAnalysis.push(value);
        });

        this.setState({
            stage: Stage.confirm,
        });
    }

    _handleSelectionCancel = () => {
        this.setState({
            stage: Stage.initial,
            overlayInfo: {},
        });
    }

    _handleConfirmNext = () => {
        this.setState({
            stage: Stage.done,
            overlayInfo: {},
        });
    }

    _handleConfirmCancel = () => {
        this.setState({
            stage: Stage.initial,
            overlayInfo: {},
        });
    }

    _handleDoneOk = () => {
        this.setState({
            stage: Stage.initial,
            overlayInfo: {},
        });
    }

    _setEmptyList = () => {
        this.setState({
            regionListTimestamp: Date.now(),
            regionList: [],
        });
    }

    _processError = (error) => {
        if (error.response && error.response.status === 404) {
            this._setEmptyList();
            return;
        }

        if (this.props.onError) {
            this.props.onError(error);
        }
    }
}

Tasking.propTypes = {
    getAccessCode: PropTypes.func.isRequired,
    setAccessCode: PropTypes.func.isRequired,
    sharedProps: PropTypes.object.isRequired,
    setSharedProps: PropTypes.func.isRequired,
    onError: PropTypes.func,
}

export default withStyles(styles)(Tasking);
